var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rectangle",class:{ 'disable-rectangle': _vm.modalActive },style:(_vm.customStyle()),attrs:{"id":_vm.data.id},on:{"mouseover":_vm.mousOver,"mouseleave":_vm.mouseOut,"click":function($event){return _vm.showElement(_vm.data)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }